import PropTypes from "prop-types";

export default {
	value: PropTypes.number,
	min: PropTypes.number,
	max: PropTypes.number,
};
